import pMemoize, { PMemoizeOption } from "../../utils/pMemorize"
import { FetchValueDecorator } from "./LazyValue"

export const pMemoizeDecorator = <V extends Promise<any>, P>(
  options?: PMemoizeOption,
): FetchValueDecorator<P, V> => {
  return fetchValue => {
    return pMemoize(fetchValue, options)
  }
}
